import FlightSegmentAlternatives from './flight-segment-alternatives-component';
import FlightSegmentAlternativesService from './flight-segment-alternatives-service';

import './flight-segment-alternatives.scss';

const MODULE_NAME = 'app.flight.segment.alternatives';
const module = angular.module(MODULE_NAME, [])
    .directive(FlightSegmentAlternatives.DIRECTIVE_NAME, FlightSegmentAlternatives)
    .service('flightSegmentAlternativesService', FlightSegmentAlternativesService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-segment-alternatives/flight-segment-alternatives-module.js